// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1527":"b96f1247","4282":"9dcf7c7c","6777":"9dcf7c7c"}[chunkId] + ".chunk.css";
};